import { Th, Thead, Tr } from "@chakra-ui/react";

import { ChakraText } from "components/ChakraText";

const AppointmentsTableHeader = () => {
  return (
    <Thead>
      <Tr>
        <Th>
          <ChakraText>Termin wizyty</ChakraText>
        </Th>
        <Th>
          <ChakraText>Podmiot</ChakraText>
        </Th>
        <Th>
          <ChakraText>Kolejka</ChakraText>
        </Th>
        <Th>
          <ChakraText>Grupa</ChakraText>
        </Th>
        <Th>
          <ChakraText>Status</ChakraText>
        </Th>
        <Th>
          <ChakraText>Akcje</ChakraText>
        </Th>
      </Tr>
    </Thead>
  );
};

export { AppointmentsTableHeader };
